import React from 'react';

const HealthClinicsPage = () => {
  return (
    <div>
      <h1>Health Clinics</h1>
    </div>
  );
};

export default HealthClinicsPage;
